import { IAriaAttributeProps } from '@kurtosys/types/accessibility/IAriaAttributeProps.js';
import { IAriaAttributes } from '@kurtosys/types/accessibility/IAriaAttributes.js';

export function orchestrateAriaAttributeProps(aria: IAriaAttributeProps): IAriaAttributes {
	return Object.keys(aria).reduce((props, ariaKey) => {
		props[`aria-${ariaKey}`] = aria[ariaKey];
		return props;
	}, {} as IAriaAttributes);
}
